(function ($) {
  productContentHotlistV1 = {
    formatter: $('.product-content-hotlist-v1')
  };

  Drupal.behaviors.productContentHotlistV1 = {
    get: function (key) {
      return productContentHotlistV1[key];
    },

    set: function (key, val) {
      productContentHotlistV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // draw with L2 cache
        $(document).on('inventory_status_stored', function () {
        // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
          $(page_data['product-input-type'].products).each(function (i, product) {
            if (typeof product.skus !== 'undefined') {
              var isOrderableSku = $(product.skus).filter(function () {
                if (typeof $(document).data(this.SKU_ID) != 'undefined') {
                  return ($(document).data(this.SKU_ID).isOrderable == 1)
                      || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3);
                }
              })[0];
              var isDisplayableSku = $(product.skus).filter(function () {
                var undef;
                var sku = $(document).data(this.SKU_ID);

                return typeof site.features.spp_displayable_status !== 'undefined'
                && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
              })[0];

              if (typeof isOrderableSku == 'undefined' && !isDisplayableSku) {
              // remove product - removed completely so the quickshop positioning remains correct
                $('div.mpp-box[data-productid="' + product.PRODUCT_ID + '"]').parent().remove();
              } else {
                $('div.mpp-box[data-productid="' + product.PRODUCT_ID + '"]').parent().addClass('hasValidSku');
              }
            }
          });
          // remove those that lack any skus, let alone any valid ones...
          // $('.pcg-product-large-v1').not('.hasValidSku').remove();

          // setup rows of 3
          var items = thisFormatter.find('.inner');
          // Check if the SKU have more than 1 shade
          var pcgProductsSku = items.find('.pcg-product-large-v1');

          pcgProductsSku.each(function () {
            var pcgProductSku = $(this),
              shadeBox = pcgProductSku.find('.product-shade .shade-box'),
              skuShade = shadeBox.attr('data-skushade');

            if (skuShade !== undefined) {
              var shades = skuShade.split(',').length,
                shade = skuShade.split(',');

              if (shades === 1) {
                shadeBox.addClass('single-shade');
              } else {
              // If there are 2 or more shades add multi-shade class and hide shade-box
                shadeBox.addClass('multi-shade');
                $('.multi-shade').closest('.product-shade').addClass('multi-shade-parent');
                $('.multi-shade').hide();
                // Iterate through available shades and rebuild shade-box divs
                for (var i = 0; i < shades; i++) {
                  pcgProductSku.find('.product-shade.multi-shade-parent').prepend('<div style="background-color: ' + shade[i] + '" class="shade-box single-shaded item-' + i + '"></div>');
                  pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded.item-0').addClass('first').css({ 'margin-right': '6px' });
                  var width;

                  // We don't know how many shades could be in a SKU
                  // Let's deal with up to 5
                  switch (shades) {
                    case 2:
                      width = '9px';
                      break;
                    case 3:
                      width = '6px';
                      break;
                    case 4:
                      width = '4px';
                      break;
                    case 5:
                      width = '3px';
                      break;
                    default:
                      width = '2px';
                  }
                  pcgProductSku.find('.product-shade.multi-shade-parent').find('.shade-box.single-shaded').css({
                    'width': width,
                    'margin-right': '1px'
                  });
                }
              }
            }
          });

          // search the .inner "lining"/block and its first level children, to see if their contents are empty or full,
          // and if empty, remove these items from the list
          items.each(function () {
            var item = $(this),
              itemContents = item.children();

            if (itemContents.length === 0 || itemContents.children().length === 0) {
              item.parent('li').remove();
            }
          });
          // now refresh the nodes present in this list, so items only contains those .inner nodes still in the DOM
          items = $(items.selector, items.context);

          for (var i = 0; i < items.length; i += 3) {
            items.slice(i, i + 3).wrapAll('<div class="row"></div>');
          }
        });

        // populate share links
        var id = thisFormatter.attr('id');
        var shareLink = encodeURIComponent(window.location.origin + window.location.pathname + '#' + id);
        var placeholders = { '%SHARE_LINK%': shareLink };
        var strings = thisFormatter.find('.share-button');

        strings.each(function () {
          var href = $(this).attr('href');

          href = href.replace(/%\w+%/g, function (all) {
            return placeholders[all] || all;
          });
          $(this).attr('href', href);
        });
      });
    }
  };
})(jQuery);
